import React from 'react';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import APLogo from '@t7x000/apex-web/lib/components/common/APLogo/APLogo.js';
import './StandAloneLayout.css';

const layoutClasses = getBEMClasses('standalone-layout');

const StandAloneLayout = props => (
  <div className={layoutClasses('wrapper')}>
    <APLogo customClass={layoutClasses('logo')} linkTo="/" />
    {props.children}
  </div>
);

export default StandAloneLayout;
